// Copyright (c) 2016 Deere & Company

import actions from '../../../action-list';
import {getDefaultState as getKeyValuePairCollectionDefaultState} from '@deere/cps-it.warranty-model-factory/lib/key-value-pair-collection';

export const resetMccQuestions = () => ({
    data: getKeyValuePairCollectionDefaultState(),
    type: actions.UPDATE_CLAIM_MCC_FOLLOWUP_MCC_QUESTIONS
});



// WEBPACK FOOTER //
// ./src/claim/marketing/mass-channel-customer-followup/action-creators/reset-mcc-questions.js